import Loading from '@components/Loading';
import useOrderPaymentFail from '@hooks/analytics/useOrderPaymentFail';
import { CreateOrderRequest } from '@models/order';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { orderActions } from '@store/order/orderSlice';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';

interface Params {
    code: string;
    message: string;
}

declare module '@stackflow/config' {
    interface Register {
        TossOrderFailActivity: Params;
    }
}

const TossOrderFailActivity: ActivityComponentType<'TossOrderFailActivity'> = ({ params }) => {
    const { code, message } = params;
    const [cookies] = useCookies(['tempOrder'], { doNotParse: true });
    const dispatch = useDispatch();
    const { push, replace } = useFlow();
    const sendOrderPaymentFail = useOrderPaymentFail();
    useEffect(() => {
        console.error({ code, message });
        sendOrderPaymentFail({ fail_code: code, fail_message: message });
        replace('MainActivity', {}, { animate: false });
        try {
            const tempOrder: CreateOrderRequest = JSON.parse(cookies.tempOrder);
            const { shopId } = tempOrder;
            const itemId = tempOrder.orderLines.map((line) => line.shopItemId)
                ?.[0];
            push('ShopListActivity', { type: 'LIST', isOrder: true }, { animate: false });
            push('ItemsActivity', { type: 'ALL', shopId }, { animate: false });
            push('ItemActivity', { itemId, shopId }, { animate: false });
            push('OrderActivity', { }, { animate: false });
            dispatch(orderActions.copy(JSON.parse(cookies.tempOrder!)));
        } catch (e) {
            console.error(e);
            replace('MainActivity', {});
        } finally {
            toast.error('주문에 실패하였습니다.');
        }
    }, []);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};
export default TossOrderFailActivity;
